export const valueExceptionCard = '.cards.cac';
export const TransferCookie = 'SharedSessionOrg';
